<template>
    <div class="scene-box" :class="!noBg?'bg':''">
        <!--group-->
        <group-list
                :curr-group-id="currentGroupIdx"
                :group-list="sceneGroups"
                @titleClick="titleClick"
                :is-edit="false"
                :white-bg="!noBg"
        ></group-list>
        <!--scenes-->
        <scene-list
                :curr-scene="selScene"
                :scenes-list="sceneGroups[currentGroupIdx].scenes"
                @loadScene="loadScene"
                :all-scenes="totalScene"
                :is-edit="false"
        ></scene-list>
    </div>
</template>

<script>
    import SceneList from "./SceneList";
    import GroupList from "./GroupList";
    import {mapGetters} from "vuex";

    export default {
        name: "SceneSelect",
        components: {SceneList, GroupList},
        props:{
            noBg:{
                type: Boolean,
                default: true
            },
            selScene: {
                type: Array,
                default: ()=>[]
            },
            allScene:{
                type: Object,
                default: ()=>{}
            }
        },
        computed: {...mapGetters(["vrbase"])},
        data(){
            return{
                sceneGroups: [],
                currentGroupIdx: 0,
                totalScene:{}
            }
        },
        watch:{
            allScene:{
                handler(newVal){
                    console.log('allScene的新值',newVal)
                    if(newVal){
                        this.totalScene = newVal
                    }
                },
                deep: true
            }
        },
        created() {
            this.sceneGroups = this.vrbase.scene_group.groups;
            if(this.allScene){
                this.totalScene = this.allScene
            }else{
                this.totalScene = this.vrbase.scenes
            }
        },
        methods: {
            //切換組
            titleClick(index) {
                this.currentGroupIdx = index;
            },
            //切換分組
            loadScene(sceneId) {
                this.$emit('changeScene',sceneId)
            },
        }
    }
</script>

<style lang="less" scoped>
    .scene-box{
        width: 100%;
        &.bg{
            // background-color: rgba(0,0,0,.5);
        }
    }
</style>